import React, { useState } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import styled from "styled-components"
import WithCollection from "areas/collection/hoc/with-collection"

const Icon = styled.img`
  height: 20px;
  left: 20px;
  position: absolute;
  top: 5px;
  width: 20px;
  z-index: 1;
`

const InternalWishlistIcon = ({
  confirmWishlist,
  product,
  setProductParams,
  toggleAddToWishlist,
  isWishlistAdding,
}) => {
  return (
    <Icon
      alt="add to wishlist"
      height="30"
      id="col_add_to_wishlist"
      onClick={(e) =>
        !isWishlistAdding &&
        toggleAddToWishlist(confirmWishlist, setProductParams, e)
      }
      src={
        product.wishlistAdded
          ? require("images/icons/heart_filled_pink.svg")
          : require("images/icons/heart_outline_black.svg")
      }
      style={{ cursor: "pointer" }}
      width="30"
    />
  )
}

InternalWishlistIcon.propTypes = {}

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {}
}

const WishlistIcon = connect(
  mapStateToProps,
  mapDispatchToProps
)(WithCollection(InternalWishlistIcon))

export default WishlistIcon
